import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap, Activity, CheckCircle, DollarSign } from 'lucide-react';

interface AutomationStatsCardsProps {
  stats: {
    activeRules: number;
    totalExecutions: number;
    successRate: number;
    savingsEstimate: number;
  };
}

const AutomationStatsCards: React.FC<AutomationStatsCardsProps> = ({ stats }) => {
  const { t } = useTranslation();

  const cards = [
    {
      label: t('automation.stats.activeRules', 'Active Rules'),
      value: stats.activeRules,
      icon: Zap,
      bg: 'bg-primary-100 dark:bg-primary-900/50',
      color: 'text-primary-600 dark:text-primary-400'
    },
    {
      label: t('automation.stats.totalExecutions', 'Total Executions'),
      value: stats.totalExecutions,
      icon: Activity,
      bg: 'bg-blue-100 dark:bg-blue-900/50',
      color: 'text-blue-600 dark:text-blue-400'
    },
    {
      label: t('automation.stats.successRate', 'Success Rate'),
      value: `${stats.successRate}%`,
      icon: CheckCircle,
      bg: 'bg-green-100 dark:bg-green-900/50',
      color: 'text-green-600 dark:text-green-400'
    },
    {
      label: t('automation.stats.savingsGenerated', 'Savings'),
      value: `R$ ${stats.savingsEstimate.toLocaleString('pt-BR')}`,
      icon: DollarSign,
      bg: 'bg-emerald-100 dark:bg-emerald-900/50',
      color: 'text-emerald-600 dark:text-emerald-400'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => {
        const Icon = card.icon;
        return (
          <div key={idx} className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
            <div className="flex items-center gap-3">
              <div className={`p-2.5 rounded-xl ${card.bg}`}>
                <Icon className={`w-5 h-5 ${card.color}`} />
              </div>
              <div>
                <p className="text-xs text-gray-500 dark:text-gray-400">{card.label}</p>
                <p className="text-xl font-bold text-gray-900 dark:text-white">{card.value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AutomationStatsCards;
